import { render, staticRenderFns } from "./LearnAboutScreens.vue?vue&type=template&id=4af6e0bb&scoped=true"
import script from "./LearnAboutScreens.vue?vue&type=script&lang=js"
export * from "./LearnAboutScreens.vue?vue&type=script&lang=js"
import style0 from "./LearnAboutScreens.vue?vue&type=style&index=0&id=4af6e0bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6e0bb",
  null
  
)

export default component.exports